import React, { useEffect, useRef, useState } from "react";
import Button from "@8x8/oxygen-button";
import ReactQuill from "react-quill";
import styled from "styled-components";

const Container = styled.div`
  display: block;
`;

const MarginTopButton = styled(Button)`
  margin-top: 16px;
`;

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
];

export const TextEditor = (props) => {
  const [newText, setNewText] = useState("");
  const editorRef = useRef();

  useEffect(() => {
    setNewText(props.value || "");
  }, [props.value]);

  return (
    <Container>
      <ReactQuill
        ref={editorRef}
        theme="snow"
        value={newText}
        onChange={setNewText}
        modules={{
          toolbar: toolbarOptions,
        }}
      />
      <MarginTopButton
        data-testid={"save-" + props.testId}
        size="small"
        variant="success"
        onClick={() => {
          props.onChange(newText);
        }}
      >
        Save
      </MarginTopButton>
    </Container>
  );
};
